// removed by extract-text-webpack-plugin
module.exports = {"card-container":"card-container_ChannelCard","cardContainer":"card-container_ChannelCard","card":"card_ChannelCard","title":"title_ChannelCard","sub-feed-container":"sub-feed-container_ChannelCard","subFeedContainer":"sub-feed-container_ChannelCard"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubChannelCard/ChannelCard.scss
// module id = 254
// module chunks = 0